const DEFAULT_LOCALE_CODE = 'en-US';
const GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';
const GOLD_COPY_NOT_AVAILABLE_TEXT = 'Gold Copy is not available.';
const TRANSLATION_NOT_AVAILABLE_TEXT = 'Translation is not available.';

/**
 * The rules available to apply to fields on a topic. The rule that is applied to a field
 * changes how it will be stored in the data lake, if it's stored at all.
 * 
 * These rules match rules defined in Tributary.
 */
const topicFieldRules = {
    ALLOWED: 'ALLOWED',
    IGNORED: 'IGNORED'
    // ...
};

module.exports = {
    DEFAULT_LOCALE_CODE,
    GOLD_COMPANY_ID,
    GOLD_COPY_NOT_AVAILABLE_TEXT,
    TRANSLATION_NOT_AVAILABLE_TEXT,
    topicFieldRules
};
